export const PublishErrorCode = {
  AUTH_TOKEN_EXPIRED: 'AUTH_TOKEN_EXPIRED',
  AUTH_NO_REFRESH_TOKEN: 'AUTH_NO_REFRESH_TOKEN',
  AUTH_REFRESH_FAILED: 'AUTH_REFRESH_FAILED',
  AUTH_PERMISSION_MISSING: 'AUTH_PERMISSION_MISSING',
  RATE_LIMIT: 'RATE_LIMIT',
  API_ERROR: 'API_ERROR',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  UNSUPPORTED_MEDIA: 'UNSUPPORTED_MEDIA',
  MEDIA_DOWNLOAD_FAILED: 'MEDIA_DOWNLOAD_FAILED',
  CONTENT_POLICY: 'CONTENT_POLICY',
  SYSTEM_ERROR: 'SYSTEM_ERROR',
  UNKNOWN: 'UNKNOWN',
} as const;

export type PublishErrorCodeType = typeof PublishErrorCode[keyof typeof PublishErrorCode];

export const ErrorCategory = {
  AUTH: 'auth',           // Requires reconnecting account
  RATE_LIMIT: 'rate_limit', // Will retry automatically
  VALIDATION: 'validation', // Requires editing post
  SYSTEM: 'system',       // Auto-retry or report issue
} as const;

export type ErrorCategoryType = typeof ErrorCategory[keyof typeof ErrorCategory];

// Map error codes to categories
export const ErrorCodeToCategory: Record<PublishErrorCodeType, ErrorCategoryType> = {
  [PublishErrorCode.AUTH_TOKEN_EXPIRED]: ErrorCategory.AUTH,
  [PublishErrorCode.AUTH_NO_REFRESH_TOKEN]: ErrorCategory.AUTH,
  [PublishErrorCode.AUTH_REFRESH_FAILED]: ErrorCategory.AUTH,
  [PublishErrorCode.AUTH_PERMISSION_MISSING]: ErrorCategory.AUTH,
  [PublishErrorCode.RATE_LIMIT]: ErrorCategory.RATE_LIMIT,
  [PublishErrorCode.API_ERROR]: ErrorCategory.SYSTEM,
  [PublishErrorCode.VALIDATION_ERROR]: ErrorCategory.VALIDATION,
  [PublishErrorCode.UNSUPPORTED_MEDIA]: ErrorCategory.VALIDATION,
  [PublishErrorCode.MEDIA_DOWNLOAD_FAILED]: ErrorCategory.SYSTEM,
  [PublishErrorCode.CONTENT_POLICY]: ErrorCategory.VALIDATION,
  [PublishErrorCode.SYSTEM_ERROR]: ErrorCategory.SYSTEM,
  [PublishErrorCode.UNKNOWN]: ErrorCategory.SYSTEM,
};
